import { render, staticRenderFns } from "./Forp1.vue?vue&type=template&id=4d765786&scoped=true"
import script from "./Forp1.vue?vue&type=script&lang=js"
export * from "./Forp1.vue?vue&type=script&lang=js"
import style0 from "./Forp1.vue?vue&type=style&index=0&id=4d765786&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d765786",
  null
  
)

export default component.exports